<label>{{label}}</label>
<input type="text" class="form-control" [value]="innerValue" (input)="inputUpdate($event)" (blur)="blurUpdate()"
    placeholder="mm/dd/yyyy" [disabled]="disabled" maxlength="10">